export default {
	project: {
		my_xs: 'Mes décisions',
		fields: {
			name: 'Titre',
			name_explanation: 'Fournissez un titre pour votre projet',
			description: 'Mission',
			description_explanation: 'Énoncez votre mission globale',
			vision: 'Vision',
			vision_explanation: 'Énoncez la vision à long terme du projet',
			description_long: 'Description',
			description_long_explanation: "Ex. : « PME suisse de mécatronique, 200 personnes, marché automobile européen. Mission : devenir leader des capteurs intelligents d'ici 2030. »",
			description_long_hint: "Plus la description est précise (secteur, taille, mission), plus l'analyse est juste.",
			description_long_warning_title: 'Description succincte',
			description_long_warning_body: "Votre description fait {{count}} caractères. L'IA risque d'inférer un secteur ou un contexte qui ne correspond pas à votre organisation. Voulez-vous l'enrichir avant de lancer ?",
			description_long_warning_enrich: 'Enrichir',
			description_long_warning_continue: 'Lancer quand même',
			ai_context: "Précisions et axes d'analyse",
			ai_context_explanation: "Indiquez les angles, acteurs ou contraintes que l'analyse doit privilégier (ex. un concurrent en particulier, une dimension réglementaire, un territoire, une contrainte temporelle…).",
			fishbone_description: 'Plan stratégique - À être',
			fishbone_description_explanation: '',
			reference: 'Référence',
			tags: 'Tags',
			likelihoods: 'Probabilités',
			impacts: 'Impacts',
			types: {
				stakeholders: 'Parties prenantes',
				stakeholders_long: 'Projet parties prenantes',
				stakeholders_explanation: 'Aligner les forces en présence',
				risks: 'Risques',
				risks_long: 'Projet risques',
				risks_explanation: 'Transformez vos risques en ouvertures',
				pro: 'Exécution stratégique',
				pro_long: 'Projet exécution stratégique',
				pro_explanation: 'Implémentez avec agilité'
			},
			ai: {
				scenarios: {
					title: "Scénarios à explorer",
					hint: "Traités par l'IA privée — aucune information transmise à l'extérieur. Vous pouvez modifier le texte, l'horizon temporel, en ajouter ou en retirer.",
					most_likely_label: "Le plus probable",
					most_likely_default: "Trajectoire la plus probable si les tendances actuelles se poursuivent : ni catastrophe, ni euphorie — la projection médiane des risques et des ouvertures déjà identifiés.",
					worst_label: "Pire cas",
					worst_default: "Les risques majeurs se réalisent, les ouvertures sont manquées, les parties prenantes s'opposent.",
					best_label: "Meilleur cas",
					best_default: "Les risques sont maîtrisés, les ouvertures saisies, les parties prenantes coopèrent.",
					add: "Ajouter un scénario",
					remove: "Retirer ce scénario",
					label_placeholder: "Nom du scénario",
					content_placeholder: "Hypothèses, événements clés, conditions de réalisation…"
				},
				horizon_unit: {
					d: "jours",
					w: "semaines",
					m: "mois",
					y: "années"
				}
			},
		},
		messages: {
			delete_confirmation: 'Supprimer projet',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer le projet "{{name}}" ? Cette action ne peut pas être annulée.',
			clone_confirmation: 'Cloner le projet',
			clone_confirmation_explanation:
				'Êtes-vous sûr de vouloir cloner ce projet ?',
			clone_in_progress:
				'Nous clonons votre projet, veuillez patienter...',
			delete_in_progress:
				'Nous supprimons votre projet, veuillez patienter...'
		},
		actions: {
			edit: 'Modifier projet',
			delete: 'Supprimer projet',
			clone: 'Cloner le projet',
			open: 'Ouvrir le projet'
		},
		shared_with_me: 'Partagé avec vous (lecture seule)',
		readers_count: '{{count}} lecteur(s)',
		share: {
			tab: 'Partage',
			description:
				'Invitez des personnes à consulter ce projet en lecture seule. Elles ne pourront rien modifier ni générer.',
			email_placeholder: 'email@exemple.com',
			invite: 'Inviter',
			invalid_email: 'Adresse email invalide',
			already_member: 'Cette personne a déjà accès',
			invited: 'Invitation envoyée',
			invite_failed: "Échec de l'invitation",
			no_members: 'Aucun lecteur pour le moment',
			role_reader: 'Lecteur',
			revoke_confirm: 'Révoquer cet accès ?',
			revoked: 'Accès révoqué',
			revoke_failed: 'Échec de la révocation'
		}
	},
	option: {
		fields: {
			name_explanation: 'Veuillez entrer un nom pour cette option'
		}
	},
	item: {
		name: 'Partie prenante',
		name_plural: 'Parties prenantes',
		activeness_zones: {
			external_outer_positive: 'Neutre',
			external_inner_positive: 'Inactif',
			external_outer_negative: 'Neutre',
			external_inner_negative: 'Inactif',

			internal_low_positive: 'Faible',
			internal_medium_positive: 'Moyen',
			internal_high_positive: 'Élevé',
			internal_low_negative: 'Faible',
			internal_medium_negative: 'Moyen',
			internal_high_negative: 'Élevé',

			internal_positive: 'Catalyseurs',
			internal_negative: 'Inhibiteurs'
		},
		messages: {
			delete_confirmation: 'Supprimer partie prenante',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cette partie prenante ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer la partie prenante pour ce scénario, fermez cette fenêtre, sélectionnez-la et dans la colonne de droite, cliquez sur le bouton "œil" pour la désactiver pour ce scénario.'
		},
		fields: {
			name: 'Nom',
			description: 'Description',
			links: {
				outcoming: {
					name: 'Liens sortants'
				},
				incoming: {
					name: 'Liens entrants'
				}
			},
			stakes: {
				name: "Relations d'enjeux"
			},
			indicators: {
				name: "Relations d'indicateurs"
			},
			risks: {
				name: 'Relations de risques'
			},
			opportunities: {
				name: "Relations d'ouvertures"
			},
			impact: {
				label: 'Importance',
				level: {
					low: 'Faible',
					medium: 'Moyen',
					high: 'Élevé'
				}
			},
			trend: {
				label: 'Tonalité',
				level: {
					green: 'Positif',
					neutral: 'Neutre',
					orange: 'À risque',
					red: 'Négatif'
				}
			}
		},
		actions: {
			create_new: 'Créer partie prenante',
			edit: 'Modifier les détails',
			delete: 'Supprimer partie prenante',
			clone: 'Cloner la partie prenante'
		},
		no_x: 'Aucune partie prenante',
		engagement: 'Engagement',
		importance: 'Importance',
		trust: 'Tonalité',
		levels: {
			low: 'Faible',
			medium: 'Moyen',
			high: 'Élevé',
			inactive_neutral: 'Inactif / Neutre',
			positive: 'Positif',
			positive_short: 'Pos.',
			negative: 'Négatif',
			negative_short: 'Nég.',
			at_risk: 'À risque',
			neutral: 'Neutre'
		}
	},
	item_link: {
		no_x: 'Aucun lien',
		actions: {
			create_new: 'Créer un nouveau lien'
		}
	},
	item_comment: {
		no_x: 'Aucun historique',
		actions: {
			create_new: 'Créer un nouvel historique'
		}
	},
	tag: {
		name: 'Tag',
		name_plural: 'Tags',
		fields: {
			name: 'Tag',
			name_plural: 'Tags'
		},
		messages: {
			delete_confirmation: 'Supprimer le tag',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer ce tag ? Cette action ne peut pas être annulée.',
			no_x: 'Aucun tag'
		},
		actions: {
			add_x: 'Ajouter un tag',
			create_new: 'Créer un tag',
			edit: 'Modifier le tag',
			delete: 'Supprimer le tag'
		}
	},
	stake: {
		no_x: 'Aucun enjeu',
		name: 'Enjeu',
		name_plural: 'Enjeux',
		fields: {
			name: 'Nom',
			reference: 'Référence',
			name_plural: 'Enjeux',
			description: 'Description',
			evaluated_at: 'Évaluation',
			weight: 'Poids',
			trend: 'Statut',
			risks: {
				name: 'Relations de risques',
				name_positive: "Relations d'ouvertures"
			},
			trend_tier: {
				strained: 'Précaire',
				mixed: 'Mitigé',
				solid: 'Soutenu'
			}
		},
		actions: {
			delete: 'Supprimer enjeu',
			edit: "Modifier l'enjeu",
			create_new: 'Créer un enjeu'
		},
		message: {
			no_x: 'Aucun enjeu'
		},
		messages: {
			delete_confirmation: "Supprimer l'enjeu",
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cet enjeu ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer l\'enjeu pour ce scénario, fermez cette fenêtre, sélectionnez-le et dans la colonne de droite, cliquez sur le bouton "œil" pour le désactiver pour ce scénario.'
		}
	},

	indicator: {
		name: 'Indicateur',
		name_plural: 'Indicateurs',
		no_x: 'Aucun indicateur',
		fields: {
			indicator_category: 'Catégorie',
			name: 'Nom',
			reference: 'Référence',
			name_plural: 'Indicateurs',
			evaluated_at: 'Évaluation',
			frequency: 'Fréquence',
			weight: 'Poids',
			description: 'Description'
		},
		action: {
			add_x: "Ajouter un point d'indicateur"
		},
		message: {
			no_x: 'Aucun indicateur'
		},
		messages: {
			delete_confirmation: "Supprimer l'indicateur",
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cet indicateur ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer l\'indicateur pour ce scénario, fermez cette fenêtre, sélectionnez-le et dans la colonne de droite, cliquez sur le bouton "œil" pour le désactiver pour ce scénario.'
		},
		actions: {
			delete: 'Supprimer indicateur',
			edit: "Modifier l'indicateur",
			create_new: 'Créer un indicateur'
		}
	},

	scenario: {
		name: 'Scénario',
		name_plural: 'Scénarios',
		no_x: 'Aucun scénario',
		baseline: 'Référence',
		fields: {
			name: 'Nom',
			name_long: 'Nom du scénario',
			score: 'Score du scénario',
			description: 'Description',
			impacts: 'Description des impacts',
			generate_simulation: 'Générer une simulation automatiquement',
			simulation_query: 'Hypothèse et horizon de la simulation'
		},
		placeholders: {
			simulation_query:
				"Ex: Que se passerait-il si le prix du pétrole augmentait de 50% d'ici 2 ans ? Quelles seraient les conséquences sur les parties prenantes et les risques identifiés ?"
		},
		messages: {
			delete_confirmation: 'Supprimer le scénario',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer ce scénario ? Cette action ne peut pas être annulée.',
			switch_scenario: 'Passer à la référence ou à un autre scénario',
			creation_in_progress:
				'Veuillez patienter pendant la préparation de votre scénario...',
			simulation_explanation:
				"L'IA analysera votre hypothèse et proposera des modifications aux parties prenantes, risques et enjeux du projet pour simuler ce scénario.",

			promote_as_baseline: {
				title: 'Promouvoir ce scénario comme nouvelle référence',
				explanation:
					'Êtes-vous sûr de vouloir promouvoir le scénario « <0>{{name}}</0> » comme nouvelle référence ? Cette action ne peut pas être annulée.',
				keep_current_baseline_as_scenario_question:
					"Que souhaitez-vous faire avec l'ancienne référence ?",
				keep_current_baseline_as_scenario_question_yes:
					'Je veux la conserver et lui donner le nom suivant',
				keep_current_baseline_as_scenario_question_no:
					'Rien, elle peut être supprimée',
				keep_scenario_question:
					'Souhaitez-vous conserver une copie du scénario maintenant promu comme nouvelle référence ?',
				keep_scenario_question_yes: 'Oui, conserver une copie',
				keep_scenario_question_no: "Non, je n'ai pas besoin d'une copie",
				loading: 'Promotion du scénario en cours...'
			},

			best_evaluation: 'Meilleur cas parmi tous les scénarios'
		},
		actions: {
			create_new: 'Créer un nouveau scénario à partir de la référence',
			create_new_from_baseline:
				'Créer un nouveau scénario à partir de la référence',
			save_as_new_baseline: 'Sauvegarder comme nouvelle référence',
			clone: 'Cloner le scénario',
			edit: 'Modifier le scénario',
			delete: 'Supprimer le scénario',
			next: 'Aller au scénario suivant',
			previous: 'Aller au scénario précédent',
			previous_baseline: 'Aller au scénario de référence',
			continue_with_ai: "Continuer avec l'IA"
		},
		ai: {
			toggle: 'Générer ce scénario par IA',
			toggle_subtitle:
				"À partir de ton hypothèse, l'IA proposera 4 variantes plausibles puis générera les scénarios choisis.",
			explanation:
				"Décris ton hypothèse et fixe l'horizon. L'IA proposera 4 variantes que tu pourras choisir avant de générer le ou les scénarios.",
			hypothesis_label: 'Hypothèse',
			hypothesis_placeholder:
				'Ex: Le principal concurrent annonce un partenariat exclusif avec un acteur majeur du secteur public.',
			suggestions_label: 'Suggestions adaptées à ton projet',
			click_to_use: 'Cliquer pour utiliser cette suggestion',
			no_suggestions: 'Pas de suggestions disponibles pour le moment.',
			suggestions_error: "Impossible de générer les suggestions pour le moment.",
			horizon_label: 'Horizon',
			horizon_unit_label: 'Unité',
			scope_label: 'Périmètre (optionnel)',
			scope_placeholder: 'Ex: filiale Europe, segment B2B, M&A en cours…',
			focus_axes_label: 'Axes de focus (optionnel)',
			focus_axes_placeholder: 'Choisir un ou plusieurs axes',
			zone_public_tooltip:
				"Le sujet du projet et l'hypothèse sont neutralisés (in-VPC) avant d'être transmis à la recherche publique pour collecter parties prenantes externes, précédents comparables, signaux faibles et dynamiques sectorielles.",
			public_note:
				'À la génération, une recherche publique sera lancée sur un sujet anonymisé pour collecter parties prenantes externes, précédents comparables, signaux faibles et dynamiques sectorielles.',
			modal_title: 'Génération de scénario par IA',
			variants_intro:
				'Voici les variantes proposées pour ton hypothèse. Coche celles que tu veux développer en scénarios.',
			requesting_variants: 'Génération des variantes en cours…',
			validate_count: 'Valider ({{count}})',
			interrupted: 'Génération interrompue (connexion perdue ou délai serveur dépassé). Crée un nouveau scénario pour relancer la génération.',
			result_too_large: 'Le résultat de la génération est trop volumineux pour être récupéré. Relance la génération.',
			modifications: 'Modifications',
			new_elements: 'Nouveaux éléments',
			no_changes: "Aucune modification proposée par l'IA.",
			review_title: 'Revue des changements proposés',
			review_subtitle: 'Coche / décoche puis valide',
			review_hint: 'Décoche un élément pour ne pas l\'importer dans le scénario.',
			badge_new: 'Nouveau',
			before_label: 'Avant',
			value: {
				disabled: 'Désactivé'
			},
			step: {
				loading_project: 'Chargement du contexte projet…',
				preparing_prompt: 'Préparation de la requête IA…',
				asking_ai: 'Analyse par l\'IA…',
				parsing_variants: 'Mise en forme des variantes…',
				reformulating: 'Reformulation neutre du sujet…',
				deep_research: 'Recherche publique anonymisée…',
				private_analysis: 'Analyse privée du scénario…',
				processing_stakeholders: 'Calcul des impacts parties prenantes…',
				processing_stakes: 'Calcul des impacts enjeux…',
				processing_risks: 'Calcul des impacts risques…',
				processing_indicators: 'Calcul des impacts contraintes…',
				reformatting: 'Mise en forme des résultats…',
				started: 'Démarrage…',
				completed: 'Terminé'
			},
			generate_count: 'Générer ({{count}})',
			in_progress: 'En cours…',
			done: 'Terminé',
			focus_axis: {
				regulatory: 'Réglementaire',
				market: 'Marché',
				tech: 'Technologique',
				social: 'Social',
				partnership: 'Partenarial',
				geopolitical: 'Géopolitique',
				crisis: 'Crise'
			},
			unit: {
				days: 'jours',
				weeks: 'semaines',
				months: 'mois',
				years: 'années'
			}
		}
	},
	fishbone_branch: {
		name: 'Arête',
		name_plural: 'Arêtes',
		fields: {
			completion: 'Achèvement',
			trend: 'Statut',
			name: 'Nom',
			description: 'Description',
			weight: 'Poids',
			responsible: 'Responsable',
			dates: 'Dates',
			startOn: 'Début',
			endOn: 'Fin'
		},
		messages: {
			delete_confirmation: "Supprimer l'arête du plan stratégique",
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cette arête ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer l\'arête pour ce scénario, fermez cette fenêtre, sélectionnez-la et dans la colonne de droite, cliquez sur le bouton "œil" pour la désactiver pour ce scénario.'
		},
		actions: {
			add: 'Ajouter une arête',
			clone: "Cloner l'arête",
			edit: "Modifier l'arête",
			delete: "Supprimer l'arête"
		}
	},
	fishbone_item: {
		name: 'Sous-arête',
		name_plural: 'Sous-arêtes',
		fields: {
			name: 'Nom',
			description: 'Description',
			completion: 'Achèvement',
			trend: 'Statut',
			weight: 'Poids',
			responsible: 'Responsable',
			startOn: 'Début',
			endOn: 'Fin',
			dates: 'Dates'
		},
		messages: {
			delete_confirmation: 'Supprimer la sous-arête',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cette mesure ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer la mesure pour ce scénario, fermez cette fenêtre, sélectionnez-la et dans la colonne de droite, cliquez sur le bouton "œil" pour la désactiver pour ce scénario.'
		},
		actions: {
			add: 'Ajouter une sous-arête',
			clone: 'Cloner la sous-arête',
			edit: 'Modifier la sous-arête',
			delete: 'Supprimer la sous-arête'
		}
	},
	risk: {
		name: 'Risque',
		name_plural: 'Risques',
		name_positive: 'Ouverture',
		name_plural_positive: 'Ouvertures',
		fields: {
			name: 'Nom',
			description: "Description - Indicateurs d'occurrence",
			reference: 'Référence',
			risk_category: 'Catégorie',
			likelihood: 'Probabilité',
			likelihood_level: 'Niveau prob.',
			impact: 'Impact',
			impact_level: "Nom du niveau d'impact",
			matching_opportunity: 'Ouverture',
			matching_risks: 'Relations avec les risques',
			evaluated_at: 'Évaluation',
			exposure: 'Exposition',
			exposure_positive: 'Potentiel',
			risk: 'Risque',

			opportunity: {
				name: 'Ouverture'
			}
		},
		messages: {
			delete_confirmation: 'Supprimer le risque',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer ce risque ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer le risque pour ce scénario, fermez cette fenêtre, sélectionnez-le et dans la colonne de droite, cliquez sur le bouton "œil" pour le désactiver pour ce scénario.',
			delete_opening: "Supprimer l'ouverture",
			delete_opening_explanation:
				'Êtes-vous sûr de vouloir supprimer cette ouverture ? Cette action ne peut pas être annulée et impactera tous les scénarios.\n\nSi vous souhaitez simplement masquer l\'ouverture pour ce scénario, fermez cette fenêtre, sélectionnez-la et dans la colonne de droite, cliquez sur le bouton "œil" pour la désactiver pour ce scénario.',
			no_x: 'Aucun risque',
			no_category: 'Aucune catégorie',
			no_x_positive: 'Aucune ouverture'
		},
		no_x: 'Aucun risque',
		impacts: {
			1: 'Négligeable',
			2: 'Mineur',
			3: 'Modéré',
			4: 'Majeur',
			5: 'Extrême'
		},
		likelihoods: {
			1: 'Très improbable',
			2: 'Improbable',
			3: 'Possible',
			4: 'Probable',
			5: 'Quasi certain'
		},
		actions: {
			create_new: 'Créer un nouveau risque ou ouverture',
			create: 'Ajouter un risque',
			create_opening: 'Ajouter une ouverture',
			edit: 'Modifier le risque',
			edit_opportunity: "Modifier l'ouverture",
			delete: 'Supprimer le risque',
			delete_opportunity: "Supprimer l'ouverture",
			clone: 'Cloner le risque'
		}
	},
	risk_category: {
		name: 'Catégorie',
		name_plural: 'Catégories',
		fields: {
			name: 'Nom'
		},
		messages: {
			delete_confirmation: 'Supprimer la catégorie',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action ne peut pas être annulée.',
			no_x: 'Aucune catégorie'
		},
		default_values: {
			name: {
				1: 'Existentielle',
				2: 'Stratégique',
				3: 'Opérationnelle'
			}
		},
		actions: {
			create_new: 'Créer une nouvelle catégorie',
			edit: 'Modifier la catégorie',
			delete: 'Supprimer la catégorie',
			add_x: 'Ajouter une catégorie'
		}
	},
	indicator_category: {
		name: 'Catégorie',
		name_plural: 'Catégories',
		fields: {
			name: 'Nom'
		},
		messages: {
			delete_confirmation: 'Supprimer la catégorie',
			delete_confirmation_explanation:
				'Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action ne peut pas être annulée.',
			no_x: 'Aucune catégorie',
			unassigned: 'Non assignée'
		},
		default_values: {
			name: {
				1: 'Finance',
				2: 'Clients',
				3: 'Processus internes',
				4: 'Apprentissage et croissance'
			}
		},
		actions: {
			create_new: 'Créer une nouvelle catégorie',
			edit: 'Modifier la catégorie',
			delete: 'Supprimer la catégorie',
			add_x: 'Ajouter une catégorie'
		}
	},
};
